import { EEffectAlgn, IShadowModelVal } from '@src/slide/domain/ui-model/element-modeles/property/effect/effect.interface';
import { BasePresetUtil, EMPTY_EFFECT } from './base-preset-util';
import * as ICON from '../shadow-preset-menu/preset-icons';
import { TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';
import { DefaultEffectPresetProps, EffectPropsField } from '@src/framework/editor/src/js/constants';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import _isEmpty from 'lodash/isEmpty';

const PresetIconOnShow = {
    [EMPTY_EFFECT]: ICON.DrawerEMPTY,

    'outer-45': ICON.DrawerOuter45, 'outer-90': ICON.DrawerOuter90, 'outer-135': ICON.DrawerOuter135,
    'outer-0': ICON.DrawerOuter0, 'outer-0-phai': ICON.DrawerOuter0Phai, 'outer-180': ICON.DrawerOuter180,
    'outer-225': ICON.DrawerOuter225, 'outer-270': ICON.DrawerOuter270, 'outer-315': ICON.DrawerOuter315,

    'inner-45': ICON.DrawerInner45, 'inner-90': ICON.DrawerInner90, 'inner-135': ICON.DrawerInner135,
    'inner-0': ICON.DrawerInner0, 'inner-0-phai': ICON.DrawerInner0Phai, 'inner-180': ICON.DrawerInner180,
    'inner-225': ICON.DrawerInner225, 'inner-270': ICON.DrawerInner270, 'inner-315': ICON.DrawerInner315,

    'perspective-1': ICON.DrawerPerspective1, 'perspective-2': ICON.DrawerPerspective2, 'perspective-3': ICON.DrawerPerspective3,
    'perspective-4': ICON.DrawerPerspective4, 'perspective-5': ICON.DrawerPerspective5,
};

const DefaultShadowProps = {
    color: '#000000',
    tdColor: new TDColor({ rgbaStr: '#000000' }),
    opacity: 0,
    size: 0,
    blurRad: 0,
    dir: 0,
    dist: 0,
    rotWithShape: 0,    // 外阴影该值默认为0
    isOuter: true, /** 默认是外阴影 */
};

const SHADOW_TYPE = {
    OUTER: 'outer',
    INNER: 'inner',
    PERSPECTIVE: 'perspective',
};

const OuterShadowPresetProps = {
    ...DefaultEffectPresetProps[ActionType.SHADOW],
    [EffectPropsField.ANGLE.name]: 0,
};
const InnerShadowPresetProps = {
    ...DefaultEffectPresetProps[ActionType.SHADOW],
    [EffectPropsField.OPACITY.name]: 50,
    [EffectPropsField.ANGLE.name]: 0,
    isOuter: false,
};

export const ShadowStyleAndPropsMapping = {
    'shadow-empty-click': null,
    'shadow-empty-hover': {
        [EffectPropsField.COLOR.name]: '#000000',
        [EffectPropsField.TD_COLOR.name]: new TDColor({ rgbaStr: '#000000' }),
        [EffectPropsField.OPACITY.name]: 0,
        [EffectPropsField.SIZE.name]: 0,
        [EffectPropsField.BLURRINESS.name]: 0,
        [EffectPropsField.ANGLE.name]: 0,
        [EffectPropsField.DISTANCE.name]: 0,
        isOuter: true,
    },
    'outer-45': { ...OuterShadowPresetProps, [EffectPropsField.ANGLE.name]: 45, [EffectPropsField.DISTANCE.name]: 4, [EffectPropsField.ALGN.name]: EEffectAlgn.TL },
    'outer-90': { ...OuterShadowPresetProps, [EffectPropsField.ANGLE.name]: 90, [EffectPropsField.DISTANCE.name]: 4, [EffectPropsField.ALGN.name]: EEffectAlgn.T },
    'outer-135': { ...OuterShadowPresetProps, [EffectPropsField.ANGLE.name]: 135, [EffectPropsField.DISTANCE.name]: 4, [EffectPropsField.ALGN.name]: EEffectAlgn.TR },
    'outer-0': { ...OuterShadowPresetProps, [EffectPropsField.ANGLE.name]: 0, [EffectPropsField.DISTANCE.name]: 4, [EffectPropsField.ALGN.name]: EEffectAlgn.L },
    'outer-0-phai': { ...OuterShadowPresetProps, [EffectPropsField.SIZE.name]: 102, [EffectPropsField.ALGN.name]: EEffectAlgn.CTR, [EffectPropsField.BLURRINESS.name]: 5, [EffectPropsField.DISTANCE.name]: 0 },
    'outer-180': { ...OuterShadowPresetProps, [EffectPropsField.ANGLE.name]: 180, [EffectPropsField.DISTANCE.name]: 4, [EffectPropsField.ALGN.name]: EEffectAlgn.R },
    'outer-315': { ...OuterShadowPresetProps, [EffectPropsField.ANGLE.name]: 315, [EffectPropsField.DISTANCE.name]: 4, [EffectPropsField.ALGN.name]: EEffectAlgn.BL },
    'outer-270': { ...OuterShadowPresetProps, [EffectPropsField.ANGLE.name]: 270, [EffectPropsField.DISTANCE.name]: 4, [EffectPropsField.ALGN.name]: EEffectAlgn.B },
    'outer-225': { ...OuterShadowPresetProps, [EffectPropsField.ANGLE.name]: 225, [EffectPropsField.DISTANCE.name]: 4, [EffectPropsField.ALGN.name]: EEffectAlgn.BR },

    'inner-225': { ...InnerShadowPresetProps, [EffectPropsField.ANGLE.name]: 225, [EffectPropsField.DISTANCE.name]: 4 },
    'inner-270': { ...InnerShadowPresetProps, [EffectPropsField.ANGLE.name]: 270, [EffectPropsField.DISTANCE.name]: 4 },
    'inner-315': { ...InnerShadowPresetProps, [EffectPropsField.ANGLE.name]: 315, [EffectPropsField.DISTANCE.name]: 4 },
    'inner-180': { ...InnerShadowPresetProps, [EffectPropsField.ANGLE.name]: 180, [EffectPropsField.DISTANCE.name]: 4 },
    'inner-0-phai': { ...InnerShadowPresetProps, [EffectPropsField.OPACITY.name]: 0, [EffectPropsField.BLURRINESS.name]: 9, [EffectPropsField.DISTANCE.name]: 0 },
    'inner-0': { ...InnerShadowPresetProps, [EffectPropsField.ANGLE.name]: 0, [EffectPropsField.DISTANCE.name]: 4 },
    'inner-135': { ...InnerShadowPresetProps, [EffectPropsField.ANGLE.name]: 135, [EffectPropsField.DISTANCE.name]: 4 },
    'inner-90': { ...InnerShadowPresetProps, [EffectPropsField.ANGLE.name]: 90, [EffectPropsField.DISTANCE.name]: 4 },
    'inner-45': { ...InnerShadowPresetProps, [EffectPropsField.ANGLE.name]: 45, [EffectPropsField.DISTANCE.name]: 4 },

    'perspective-1': {
        ...OuterShadowPresetProps,
        [EffectPropsField.ALGN.name]: EEffectAlgn.CTR,
        [EffectPropsField.ANGLE.name]: 128,
        [EffectPropsField.DISTANCE.name]: 24.41,
        [EffectPropsField.OPACITY.name]: 68,
        [EffectPropsField.SIZE_X.name]: 100,
        [EffectPropsField.SIZE_Y.name]: 30,
        [EffectPropsField.SKEW_X.name]: 21.67,
    },
    'perspective-2': {
        ...OuterShadowPresetProps,
        [EffectPropsField.ALGN.name]: EEffectAlgn.BL,
        [EffectPropsField.ANGLE.name]: 250,
        [EffectPropsField.DISTANCE.name]: 15.75,
        [EffectPropsField.OPACITY.name]: 68,
        [EffectPropsField.SIZE_X.name]: 100,
        [EffectPropsField.SIZE_Y.name]: 30,
        [EffectPropsField.SKEW_X.name]: -30,
    },
    'perspective-3': {
        ...OuterShadowPresetProps,
        [EffectPropsField.ALGN.name]: EEffectAlgn.B,
        [EffectPropsField.ANGLE.name]: 90,
        [EffectPropsField.DISTANCE.name]: 3,
        [EffectPropsField.OPACITY.name]: 75,
        [EffectPropsField.SIZE_X.name]: 100,
        [EffectPropsField.SIZE_Y.name]: -20,
    },
    'perspective-4': {
        ...OuterShadowPresetProps,
        [EffectPropsField.ALGN.name]: EEffectAlgn.BL,
        [EffectPropsField.ANGLE.name]: 25,
        [EffectPropsField.OPACITY.name]: 80,
        [EffectPropsField.SIZE_X.name]: 100,
        [EffectPropsField.SIZE_Y.name]: -30,
        [EffectPropsField.SKEW_X.name]: 13.34,
    },
    'perspective-5': {
        ...OuterShadowPresetProps,
        [EffectPropsField.ALGN.name]: EEffectAlgn.BL,
        [EffectPropsField.ANGLE.name]: 33.34,
        [EffectPropsField.OPACITY.name]: 80,
        [EffectPropsField.SIZE_X.name]: 100,
        [EffectPropsField.SIZE_Y.name]: -30,
        [EffectPropsField.SKEW_X.name]: -13.34,
    },
};

export class ShadowPresetUtil extends BasePresetUtil {
    protected presetIcon = PresetIconOnShow;
    protected defaultEffectProps = DefaultShadowProps;

    protected getIconName(shadowInfo: IShadowModelVal): string {
        if (_isEmpty(shadowInfo)) return EMPTY_EFFECT;
        const mainType = this.getShadowMainType(shadowInfo);
        const { dir = 0, dist = 0, size, blurRad = 0, sizeY = 0, skewX, algn } = shadowInfo;
        // 无效果
        if (dir === 0 && dist === 0 && size <= 100 && blurRad === 0) {
            return EMPTY_EFFECT;
        }
        // 有效果
        let iconName;
        if (mainType === SHADOW_TYPE.PERSPECTIVE) {
            // 透视
            iconName = this.getPerspectiveIconName(sizeY, skewX);
        } else {
            // 外阴影
            if (shadowInfo.isOuter) {
                iconName = this.getOuterIconNameByAlgn(algn);
            }
            // 内阴影
            if (!shadowInfo.isOuter) {
                iconName = this.getIconByDir(mainType, dir, dist);
            }
        }
        return iconName || EMPTY_EFFECT;
    }

    // 获取阴影主分类
    private getShadowMainType(shadowInfo: IShadowModelVal): string {
        const { isOuter, sizeX, sizeY, skewX } = shadowInfo;
        // 外阴影 | 内阴影
        let type = isOuter ? SHADOW_TYPE.OUTER : SHADOW_TYPE.INNER;
        // 透视
        if (skewX || (sizeX !== sizeY)) {
            type = SHADOW_TYPE.PERSPECTIVE;
        }
        return type;
    }

    // 获取透视图标
    // eslint-disable-next-line complexity
    private getPerspectiveIconName(sizeY: number, skewX?: number): string | undefined {
        let iconName;
        if (skewX === undefined || isNaN(skewX) || skewX === 0) {
            iconName = `${SHADOW_TYPE.PERSPECTIVE}-3`;
        } else if (skewX > 0 && sizeY > 0) {
            iconName = `${SHADOW_TYPE.PERSPECTIVE}-1`;
        } else if (skewX > 0 && sizeY < 0) {
            iconName = `${SHADOW_TYPE.PERSPECTIVE}-4`;
        } else if (skewX < 0 && sizeY > 0) {
            iconName = `${SHADOW_TYPE.PERSPECTIVE}-2`;
        } else if (skewX < 0 && sizeY < 0) {
            iconName = `${SHADOW_TYPE.PERSPECTIVE}-5`;
        }
        return iconName;
    }

    // 根据algn获取对应的外阴影图标
    private getOuterIconNameByAlgn(algn): string | undefined {
        const algnToOuter = {};
        Object.keys(ShadowStyleAndPropsMapping).forEach((key) => {
            if (key.includes(`${SHADOW_TYPE.OUTER}-`)) {
                algnToOuter[ShadowStyleAndPropsMapping[key].algn] = key;
            }
        });
        return algnToOuter[algn];
    }

    // 根据角度获取对应的外阴影或者内阴影图标
    private getIconByDir(mainType: string, dir: number, dist: number): string | undefined {
        let iconName;
        if (dir === 0 && dist === 0) {
            iconName = `${mainType}-0-phai`;
        } else if (dir === 0) {
            iconName = `${mainType}-0`;
        } else if (dir < 90) {
            iconName = `${mainType}-45`;
        } else if (dir === 90) {
            iconName = `${mainType}-90`;
        } else if (dir < 180) {
            iconName = `${mainType}-135`;
        } else if (dir === 180) {
            iconName = `${mainType}-180`;
        } else if (dir < 270) {
            iconName = `${mainType}-225`;
        } else if (dir === 270) {
            iconName = `${mainType}-270`;
        } else {
            iconName = `${mainType}-315`;
        }
        return iconName;
    }
}
